import { BrowserRouter as Router } from 'react-router-dom';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import './App.scss';
import Routes from './routes';

const App = () => {
  return (
    <div id="App">
      <Router>
        <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}>
          <Routes />
        </GoogleReCaptchaProvider>
      </Router>
    </div>
  )
}

export default App
